const TypingIndicator = ({ primaryColor, getContrastColor }) => {
  return (
    <div className="flex justify-start">
      <div 
        className="rounded-2xl px-4 py-3"
        style={{
          backgroundColor: primaryColor,
          color: getContrastColor(primaryColor)
        }}
      >
        <div className="flex gap-1">
          <div 
            className="w-2 h-2 rounded-full animate-bounce"
            style={{ 
              animationDelay: '0ms',
              backgroundColor: getContrastColor(primaryColor)
            }} 
          />
          <div 
            className="w-2 h-2 rounded-full animate-bounce"
            style={{ 
              animationDelay: '150ms',
              backgroundColor: getContrastColor(primaryColor)
            }} 
          />
          <div 
            className="w-2 h-2 rounded-full animate-bounce"
            style={{ 
              animationDelay: '300ms',
              backgroundColor: getContrastColor(primaryColor)
            }} 
          />
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;